<template>
	<page>
		<title-view>
			משחקים
			<v-btn
				slot="actions"
				color="primary"
				btn
				@click="onEdit({public:true, share:true})"
			>
				משחק חדש
			</v-btn>
		</title-view>
		<row>
			<c-col>

			</c-col>
		</row>
		<row>
			<c-col>
				<games-table
					@edit="onEdit"
					@share="onShare"
				/>
			</c-col>
		</row>
		<share-dialog
			v-model="shareDialogOpen"
			:game="shareGame"
		/>
	</page>
</template>

<script>
import GameForm from "src/view/games/GameForm";
import GamesTable from "src/view/games/GamesTable";
import GamesType from "../home/GamesType";
import GameModule from "src/store/modules/Game.module";
import ShareDialog from "dev/view/share/ShareDialog";

export default {
	name: "GamesView",
	components: { ShareDialog, GamesTable, GameForm, GamesType },
	data () {
		return {
			openModal: false,
			shareDialogOpen: false,
			shareGame: {},
		};
	},
	methods: {
		onShare (game) {
			this.shareGame = game;
			this.shareDialogOpen = true;
		},
		onEdit (game) {
			this.$store.commit(GameModule.types.GET, game);
      this.$router.push({ name: 'game-form', params: { id:game.id } }) // -> /user/123
		},
		onSave (game) {
			this.openModal = false;
			this.$store.commit(GameModule.types.GET, game);
			this.$router.push({ name: "game-form", params: { id: game.id } });
		},
	},
};
</script>

<style scoped>
</style>
